import moment from 'moment-timezone';
import React from 'react';

const UserContext = React.createContext({
  userTimeZone: moment.tz.guess()
});
class UserContextProvider extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      userTimeZone,
      children
    } = this.props;
    const value = {
      userTimeZone
    };
    return /*#__PURE__*/React.createElement(UserContext.Provider, {
      value: value
    }, children);
  }

}
const UserContextConsumer = UserContext.Consumer;

export { UserContext, UserContextConsumer, UserContextProvider };
//# sourceMappingURL=index.js.map
